import { toggleHighlight } from '../highlightEvent';
import { changeVariation } from '../tag/changeVariation';
import { EventDataFromIframe, EventDataToIframe } from './types';
import { removeTransactions } from '../tag/removeTransactions';
import { collapseQAAssistant } from '../actions/collapseQAAssistant';
import { closeQAAssistant } from '../actions/closeQAAssistant';
import { refreshPage } from '../actions/refreshPage';
import { onQaAssistantPlatform } from '../actions/onQaAssistantPlatform';
import { changeCampaign } from '../tag/changeTest';
import { forceTestTargeting } from '../tag/forceTestTargeting';

export enum MSG_NAME_FROM_IFRAME {
  QaAssistantCollapse = 'ABTASTY_QA_ASSISTANT_COLLAPSE',
  QaAssistantClose = 'ABTASTY_QA_ASSISTANT_CLOSE',
  QaAssistantAddHighlight = 'ABTASTY_QA_ASSISTANT_ADD_HIGHLIGHT',
  QaAssistantRemoveHighlight = 'ABTASTY_QA_ASSISTANT_REMOVE_HIGHLIGHT',
  QaAssistantChangeVariation = 'ABTASTY_QA_ASSISTANT_CHANGE_VARIATION',
  QaAssistantChangeTest = 'ABTASTY_QA_ASSISTANT_CHANGE_TEST',
  QaAssistantRemoveTransactions = 'ABTASTY_QA_ASSISTANT_REMOVE_TRANSACTIONS',
  QaAssistantEventNotification = 'ABTASTY_QA_ASSISTANT_EVENT_NOTIFICATION',
  QaAssistantEventRefreshPage = 'ABTASTY_QA_ASSISTANT_EVENT_REFRESH_PAGE',
  QaAssistantEventForceTestTargeting = 'ABTASTY_QA_ASSISTANT_FORCE_TEST_TARGETING',

  QaAssistantPlatform = 'ABTASTY_QA_ASSISTANT_PLATFORM',

  QaAssistantPlatformChoiceLoaded = 'ABTASTY_QA_ASSISTANT_PLATFORM_CHOICE_LOADED',

  FsApplyForcedVariations = 'FS_APPLY_FORCED_VARIATIONS',
  FsResetForcedVariations = 'FS_RESET_FORCED_VARIATIONS',
  FsQaAssistantReady = 'FS_QA_ASSISTANT_READY',
  MinimizeQaAssistantClose = 'ABTASTY_QA_MINIMIZE_QA_ASSISTANT_CLOSE',
  FsTriggerRender = 'FS_TRIGGER_RENDER',
}

export enum MSG_NAME_TO_IFRAME {
  QaAssistantHighlightNotFound = 'ABTASTY_QA_ASSISTANT_HIGHLIGHT_NOT_FOUND',
  QaAssistantTagData = 'ABTASTY_QA_ASSISTANT_TAG_DATA',
  ABTastyEvent = 'ABTasty_event',
  SegmentClickClosing = 'ABTASTY_QA_ASSISTANT_SEGMENT_CLOSE',
  QaAssistantCollapse = 'ABTASTY_QA_ASSISTANT_COLLAPSE',

  FsUpdateVisitorAllocatedVariation = 'FS_UPDATE_VISITOR_ALLOCATED_VARIATION',
  FsVisitorExposedVariation = 'FS_VISITOR_EXPOSED_VARIATION',
  FsHIT = 'FS_HIT',
}

export type HandlerMessageFromIframe = ({ data, origin }: { data: EventDataFromIframe; origin: string }) => void | null;

export const handleMessageFromIframe =
  (appUrlSrc: string): HandlerMessageFromIframe =>
  ({ data, origin }) => {
    if (!Object.values(MSG_NAME_FROM_IFRAME).includes(data.name as MSG_NAME_FROM_IFRAME)) {
      return null;
    }

    if (!appUrlSrc.startsWith(origin)) {
      console.debug('[AB Tasty][QA-Assistant] Rejecting message from unknown origin', origin);
      return null;
    }

    switch (data.name) {
      case MSG_NAME_FROM_IFRAME.QaAssistantCollapse: {
        return collapseQAAssistant(data.value);
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantAddHighlight: {
        return toggleHighlight(true, data.path);
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantRemoveHighlight: {
        return toggleHighlight(false, data.path);
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantChangeVariation: {
        const { testId, value, shouldReload } = data;
        return changeVariation(testId, value, shouldReload);
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantChangeTest: {
        const { testId, value } = data;
        return changeCampaign(testId, value);
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantRemoveTransactions: {
        return removeTransactions();
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantClose: {
        return closeQAAssistant();
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantEventRefreshPage: {
        return refreshPage();
      }
      case MSG_NAME_FROM_IFRAME.QaAssistantPlatform:
        return onQaAssistantPlatform({ url: data.value });
      case MSG_NAME_FROM_IFRAME.QaAssistantEventForceTestTargeting:
        const { testId, action } = data;
        return forceTestTargeting(testId, action);
      default:
        return null;
    }
  };

export const sendMessageToIframe = (data: EventDataToIframe) => {
  if (window.frames.ABTastyQaAssistant) {
    window.frames.ABTastyQaAssistant.postMessage(data, '*');
  }
};

export const sendMessageFromIframe = (data: EventDataFromIframe) => {
  window.parent.postMessage(data, '*');
};
